/*****************************************************
 * Packages
 ******************************************************/
import React, { useState, useContext, useCallback } from 'react';
import styled from 'styled-components';

/*****************************************************
 * Locals
 ******************************************************/
import { ElementContext, EditorContext } from '../../../ElementRenderContext';
import Tab, { TabOption } from '../reusable/Tab';
import RenderTemplate from './RenderTemplate';

/*****************************************************
 * Styles
 ******************************************************/
const tabStyle = { fontSize: '14px', marginTop: '5px' };

const Info = styled.p``;
const GroupContent = styled.div`
    margin-top: 20px;
`;

const GroupBody = ({ group, handleChange }) => {
    const [activeHover, setHover] = useState(false);
    const [lastDevice, setLastDevice] = useState('desktop');
    const { handleResponsiveEditorMode } = useContext(ElementContext);
    const { display } = useContext(EditorContext);
    const handleSetHover = useCallback(
        (payload) => {
            if (payload.value) {
                setLastDevice(display);
                handleResponsiveEditorMode('desktop');
            } else {
                handleResponsiveEditorMode(lastDevice);
            }
            setHover(payload.value);
        },
        [display, handleResponsiveEditorMode, lastDevice]
    );

    return (
        <>
            {group.hoverControl !== false && (
                <>
                    <Tab
                        height="32px"
                        style={tabStyle}
                        type="underlined"
                        selected={activeHover}
                        onSelect={handleSetHover}
                    >
                        <TabOption value={false}>NORMAL</TabOption>
                        <TabOption value={true}>HOVER</TabOption>
                    </Tab>
                    {activeHover && (
                        <Info>* You are seeing only hover supported items</Info>
                    )}
                </>
            )}

            <GroupContent>
                <RenderTemplate
                    module={group}
                    activeHover={activeHover}
                    handleChange={handleChange}
                />
            </GroupContent>
        </>
    );
};

export default React.memo(GroupBody);
